import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../lib/api';
import { useAuth } from '../context/AuthContext';
import './Login.css';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function handleSubmit() {
    setError(''); setBusy(true);
    try {
      const res = await apiFetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      if (!res.ok) { setError('Invalid email or password.'); return; }
      const data = await res.json();
      login(data.token, data.user);
      navigate('/');
    } catch (e) {
      setError('Could not reach the server. Try again.');
    } finally { setBusy(false); }
  }

  function onKeyDown(e) { if (e.key === 'Enter') handleSubmit(); }

  return (
    <div className="login-shell">
      <main className="login-card">
        <div className="login-brand">
          <img className="login-logo" src="/brand/xyz-mark.png" alt="XYZ Merchandise" />
          <div className="login-wordmark">XYZ <span>Merchandise</span></div>
        </div>
        <div className="login-eyebrow">HQ Portal</div>

        <div className="login-field">
          <span className="login-ico" aria-hidden="true">
            <svg viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg>
          </span>
          <input
            type="email" placeholder="you@xyzmerch.com" autoComplete="username"
            value={email} onChange={(e) => setEmail(e.target.value)} onKeyDown={onKeyDown}
          />
        </div>

        <div className="login-field">
          <span className="login-ico" aria-hidden="true">
            <svg viewBox="0 0 24 24"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>
          </span>
          <input
            type="password" placeholder="Password" autoComplete="current-password"
            value={password} onChange={(e) => setPassword(e.target.value)} onKeyDown={onKeyDown}
          />
        </div>

        <div className="login-row">
          <a href="/forgot">Forgot password?</a>
        </div>

        {error && <p className="login-error">{error}</p>}

        <button type="button" onClick={handleSubmit} disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>

        <div className="login-foot">XYZ MERCHANDISE LLC</div>
      </main>
    </div>
  );
}
